<title data-tid-code-title>{{ dialogData.title }}</title>
<div>
  <code>{{ dialogData.text }}</code>
</div>
<div>
  <app-button data-tid-close-button (click)="close()">CLOSE</app-button>
</div>
